import {Box,Typography} from '@mui/material'

const ItemView = ({title,content})=>{
return (
	<Box sx={{margin:1,padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
		<Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:13}}>
			{title}
		</Typography>
		<Typography color="white" ml={1} fontSize={14} sx={{whiteSpace:"pre-wrap"}}>
			{content}
		</Typography>
	</Box>
)	
}

export default ItemView

